// components/Navbar.js
// components/Navbar.js
import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import api from '../services/api';

function Navbar() {
  const { userData, logout } = useContext(UserContext);
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  /* 1️⃣ Derive admin status */
  const isAdmin = userData?.role === 'iadmin';  

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  useEffect(() => {
    if (userData) loadUnread();
  }, [userData]);

  const loadUnread = async () => {
    const res = await api.get('/session/company-sessions');
    const total = res.data.sessions.reduce(
      (sum, s) => sum + s.messages.filter(m => m.sender === 'guest').length,
      0
    );
    setUnreadCount(total);
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className="navbar">
      <div className="navbar-brand">R2D2+</div>

      <button className="hamburger" onClick={toggleMenu}>
        &#9776;
      </button>

      <div className={`navbar-menu ${menuOpen ? 'show' : ''}`}>
        <Link to="/app/dashboard" onClick={() => setMenuOpen(false)}>Home</Link>

        {!userData && (
          <>
            <Link to="/app/login"    onClick={() => setMenuOpen(false)}>Login</Link>
            <Link to="/app/register" onClick={() => setMenuOpen(false)}>Register</Link>
          </>
        )}

        {userData && (
          <>
            <Link to="/app/our-sites"              onClick={() => setMenuOpen(false)}>Our Sites</Link>
            <Link to="/app/qrcode"                 onClick={() => setMenuOpen(false)}>QR Code</Link>
            <Link to="/app/registration-overview"  onClick={() => setMenuOpen(false)}>Registrations</Link>
            <Link to="/app/questionnaire-create"  onClick={() => setMenuOpen(false)}>Create Questionnaire</Link>
            <Link to="/app/questionnaire-list"    onClick={() => setMenuOpen(false)}>List Questionnaire</Link>
          </>
        )}

        {/* 2️⃣ Use isAdmin */}
        {userData && isAdmin && (
          <>
            <Link to="/app/profile"               onClick={() => setMenuOpen(false)}>Profile</Link>
            <Link to="/app/create-site"           onClick={() => setMenuOpen(false)}>Create Site</Link>
            <Link to="/app/language-admin"        onClick={() => setMenuOpen(false)}>Languages</Link>
            <Link to="/app/create-job"            onClick={() => setMenuOpen(false)}>Create Job</Link>
            <Link to="/app/manage-jobs"           onClick={() => setMenuOpen(false)}>Manage Jobs</Link>
            <Link to="/app/company-conversations" onClick={() => setMenuOpen(false)}>Messages</Link>
            <Link to="/app/create-location"       onClick={() => setMenuOpen(false)}>Create Location</Link>
            <Link to="/app/our-locations"         onClick={() => setMenuOpen(false)}>Our Locations</Link>

          </>
        )}

        {userData && (
          <button className="navbar-logout" onClick={handleLogout}>
            Logout
          </button>
        )}
      </div>
    </nav>
  );
}

export default Navbar;